module.exports = "<div class=\"qr-progress-section\">\n  <div class=\"qr-progress-info\">\n    <span class=\"qr-progress-label\">{{ label }}</span>\n    <span class=\"qr-progress-count\" [class.qr-over]=\"isOver\">\n      {{ current }}/{{ total }} tem\n    </span>\n  </div>\n  <div class=\"qr-progress-bar\">\n    <div\n      class=\"qr-progress-fill\"\n      [style.width.%]=\"progressPercent\"\n      [style.background]=\"progressBackground\">\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/ui/qr-progress-bar/qr-progress-bar.component.html
// module id = ../../../../../src/app/components/ui/qr-progress-bar/qr-progress-bar.component.html
// module chunks = 3